<div *ngIf="doc" class="row mt-2" [ngClass]="required && docIsEmpty && !readonly ? 'border border-danger rounded p-1':''">
    <div class="col-10 d-flex align-items-center">
        <button *ngIf="!docIsEmpty && !readonly" type="button" class="btn btn-xs btn-warning float-left mr-1" paftooltip="archiver_le_fichier" style="width:30px;" 
            btnDebounceClick (debounceClick)="btnArchiveFile()">
            <i class="fas fa-archive"></i>
        </button>
        <textarea  *ngIf="!docIsEmpty || !readonly" class="form-control flex-grow-1" placeholder="Description" style="height: 40px;width:100%;" minlength="3"
            name="description" [(ngModel)]="doc.Description" [disabled]="readonly || !!doc.DocId"></textarea>
        
        <a *ngIf="!docIsEmpty" class="control-label ml-1" href="javascript:void(0);" btnDebounceClick
            (debounceClick)="btnDownloadFileClick()"
            [paftooltip]="'Telecharger_le_fichier'">{{fileName}}</a>
    </div>
    <div class="col-2">
        <div *ngIf="doc.DeposePar" class="full-width d-flex flex-column align-items-center justify-content-center">
            <label>
                Déposé le {{doc.DateDepot|date:'dd/MM/yyyy à HH:mm'}}
            </label>
            <label>
                Par {{doc.DeposePar}}
            </label>
        </div>
        <div class="float-right">        
            <div *ngIf="showUploadButton" class="ml-1 file-upload">
                <input name="fileUpload" type="file" style="width:0px;" class="file-input"
                    [accept]="requiredFileType" (change)="onFileSelected($event)" #fileUpload>
                <button type="button" class="btn btn-sm btn-primary" btnDebounceClick
                    (debounceClick)="fileUpload.click()" paftooltip="Cliquer_ou_faire_glisser_le_fichier_ici"
                    draganddrop (filesDropped)="onFilesDropped($event)"
                    [disabled]="readonly || !doc.Description">
                    <paflabel lblCod="Deposer"></paflabel>&nbsp;<i class="fas fa-paperclip"></i>
                </button>
            </div>
        </div>

    </div>
</div>
<input type="hidden"
       [ngModel]="true"
       name="internalValidator"
       #ctrl="ngModel"
       (ngModelChange)="0" />